/*
 * As ações rápidas do balcão. A lista vem do backend (OperationsAggregator: new-member, manual-entry,
 * book-class, receive-payment, renew-membership, contact-whatsapp, contact-sms) e aqui diz-se, para cada uma,
 * o ecrã que a faz de verdade.
 *
 * `to: null` = ainda não há ecrã que faça isto. O botão aparece desativado e explica-o, em vez de parecer
 * disponível e não fazer nada (era o defeito: sete botões sem onClick na Operação e na Receção).
 *
 * Terminologia: ao balcão a pessoa é um **membro** (adesão); quem treina é **atleta**.
 */
export const QUICK_ACTIONS = {
  'new-member': { label: '＋ Novo membro', to: '/admin/users' },
  'manual-entry': { label: 'Registar entrada', dialog: 'manual-entry' },
  'book-class': { label: 'Marcar aula', dialog: 'book-class' },
  'receive-payment': { label: 'Receber pagamento', to: '/admin/billing' },
  'renew-membership': { label: 'Renovar avença', to: '/admin/users' },
  'contact-whatsapp': { label: 'WhatsApp', dialog: 'whatsapp' },
  'contact-sms': { label: 'SMS', dialog: 'sms' },
};

export const quickActionFor = (key) => QUICK_ACTIONS[key] || { label: key, to: null, why: 'Ação desconhecida.' };
